export const PAYMENT_METHOD_NAMES = {
  payment_method_card: 'payment_method_card',
  payment_method_eps: 'payment_method_eps',
  payment_method_bank: 'payment_method_bank',
  payment_method_crypto: 'payment_method_crypto',
  payment_method_acard: 'payment_method_acard',
};
